import * as React from 'react'
import './CollectionSlider.scss'
import Deal from '../../models/deal'
import Collection from '../../models/collection'
import bind from 'bind-decorator'
import { Grid } from '../../components/grid'
import { Link } from 'react-router-dom'
import { CardWithData } from './index'
import shuffle from 'lodash.shuffle'

type MethodProps = {
    sliderScrollHandler: (collection: Collection) => void
}

export type FieldProps = {
    collection?: Collection
    deals?: Deal[]
    categoryName?: string
    categoryLink?: string
    shuffle?: boolean
}
export type Props = FieldProps & MethodProps

interface State {
    shuffled: boolean
    deals: Deal[] | undefined
}

class CollectionSlider extends React.Component<Props, State> {
    lastScrollX: number = 0

    constructor(props: Props) {
        super(props)

        this.state = {
            shuffled: false,
            deals: this.props.deals,
        }
    }

    componentDidUpdate() {
        if (this.props.deals && this.props.deals.length > 0 && !this.state.shuffled) {
            let deals = this.props.deals

            if (this.props.shuffle) {
                deals = shuffle(deals)
            }

            this.setState({
                deals,
                shuffled: true,
            })
        }
    }

    @bind
    onScroll(event: React.TouchEvent) {
        if (this.props.collection === undefined) {
            return
        }
        if (event.currentTarget.scrollLeft !== undefined
            && event.currentTarget.scrollLeft !== this.lastScrollX
            ) {
            this.lastScrollX = event.currentTarget.scrollLeft
            this.props.sliderScrollHandler(this.props.collection)
        }
    }

    render() {
        const { collection, categoryName, categoryLink } = this.props

        const { deals } = this.state

        if (collection === undefined || deals === undefined) {
            return null
        }

        return (
            <Grid>
                <div className='row deal-collection-title'>
                    <div className='col-xs-12'>
                        { categoryLink !== undefined &&
                        <Link to={categoryLink} className='deal-collection-title__link'>
                            <h2 className='deal-collection-title__title'>{categoryName}</h2>
                        </Link>
                        }
                        { categoryLink === undefined &&
                        <h2>{categoryName}</h2>
                        }
                    </div>
                </div>
                <div className='row deal-slider' onTouchEndCapture={this.onScroll}>
                    { deals.map((deal: Deal) =>
                        <div className='col-md-3 deal-slider__slide' key={deal.slug}>
                            <CardWithData
                                slug={deal.slug}
                                location='home'
                                type='gold'
                            />
                        </div>
                    )}
                </div>
            </Grid>
        )
    }
}

export default CollectionSlider
